import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core'
import { QuestionserviceService } from '../services/questionservice.service';
import { ExamService } from '../services/exam.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CbtserviceService } from '../services/cbtservice.service';
import { LanguageService } from '../services/language.service';
import { ScheduleQuestionAndOptions } from '../models/Exam';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { Subject } from 'rxjs';
import { QuillEditorComponent } from '../quill-editor/quill-editor.component';

declare const $: any;

@Component({
  selector: 'app-essay',
  templateUrl: './essay.component.html',
  styleUrls: ['./essay.component.css']
})
export class EssayComponent implements OnChanges, OnDestroy {
//[essayanswer]="question.essayAnswer" [scheduleid]="question.examQuestionSchedule.scheduleid" [schedulequestionid]="question.examQuestionSchedule.schedulequestionid" [maxwordcount]="question.maxwordcount"

  // @Input() essayanswer: any = "<p><b>Something </b>fishy is going on</p>"
  @Input() question: ScheduleQuestionAndOptions;
  @Input() examid: number;
  @Input() essaysubquestionid: number;
  essayanswer: string;
  quillAnswerHtml: string;
  blurred = false
  focused = false;
  @ViewChild('answer') editor: QuillEditorComponent;
  previousAnswerHtml: string;
  maxwordcount: number = 0;
  scheduleid: number;
  schedulequestionid: number;
  thisurl = location.origin + '/';
  @Output() updatedanswer: EventEmitter<string> = new EventEmitter();
  currentwordcount: number = 0;
  wordcountdisplay: string;
  higlight: boolean;
  previousQuestion: ScheduleQuestionAndOptions;
  destroyed = false;
  lastSavedTime: Date = null;
  // manualSave: boolean = false;

  @Input() loadingSubject: Subject<boolean>;
  @Input() networkFailureSubject: Subject<boolean>;


  //answerUploadUrl: string;
  constructor(public questionservice: QuestionserviceService, public examservice: ExamService, public toastr: ToastrService, public router: Router, private cbtservice: CbtserviceService, private languageService: LanguageService, private encryptdecryptservice: EncryptDecryptService) { }
  
  async ngOnDestroy(): Promise<void> {
    this.destroyed = true;
    await this.saveData(null);
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    //here, we need to know when we are switching from one question to another so that we save the data before displaying the next question
    //save the previous html before we set a new answer
    if(this.question?.examQuestion?.schedulequestionid != this.previousQuestion?.examQuestion?.schedulequestionid){
      //debugger;
      try{
        this.loadingSubject.next(true);
      //if the question has changed, save the html in the editor to the html of the previous question
        if(this.previousQuestion){
          //var data = this.constructAnswerSaveData(this.quill.root.innerHTML);

          let retryAttempt = 0;
          const baseRetryDelayMs = 1000;
          const maxRetryDelayMs = 10000;
          while (true) {
            try {
              await this.saveData(null);
              //this.networkFailureSubject.next(false);
              break;
            } catch (error) {
              console.error(error);
              //this.networkFailureSubject.next(true);
              retryAttempt++;
              const exponentialDelay = Math.min(
                Math.pow(2, retryAttempt - 1) * baseRetryDelayMs,
                maxRetryDelayMs
              );
              const jitter = Math.floor(Math.random() * 1000);
              await this.cbtservice.sleep(
                Math.min(exponentialDelay + jitter, maxRetryDelayMs)
              );
            }
          }
          //this.previousQuestion.essayAnswer = this.quill.root.innerHTML;
          
          //save that question to storage
        }
        if(this.question){
          this.previousQuestion = this.question;
          
          this.scheduleid = this.question.examination.scheduleid;
          this.schedulequestionid = this.question.examQuestion.schedulequestionid;
          this.maxwordcount = this.question.examQuestion.maxwordcount;
          const answerHtml = this.questionservice.getEssayAnswerFromStorage(this.schedulequestionid, this.essaysubquestionid);
          this.previousAnswerHtml = answerHtml;
          this.quillAnswerHtml = answerHtml;
          if(!(await this.questionservice.allowEssayAnswerInput(this.question))) {
            this.insertAnswerIntoEditor('', true);
          } else {
            this.insertAnswerIntoEditor(answerHtml, false);
          }
        } else {
          this.insertAnswerIntoEditor('', false);
        }
      }
      finally{
        // if(!environment.production){
        //   //for testing
        //   await this.cbtservice.sleep(1000);
        // }
        this.loadingSubject.next(false);
      }
    }
    
  }

  get language() {
    return this.languageService.language;
  }

  async ngOnInit() {
  }

  getWordCount(text: string): [number, number | [], number] {
    let words = text.split(/\s+/);
    let wordlength = words.length;
    let allowedwords = this.maxwordcount > 0 ? text.split(/\s+/, this.maxwordcount) : words;
    let allowedxters = this.maxwordcount > 0 ? allowedwords.join().length : text.length;
    return !text ? [0, [], 0] : [wordlength, allowedxters, text.length]
  }

  async saveData(callback) {
    //never use this.question here
    //this.question may have been updated earlier than the other relevant info
    //those are manually changed in onChanges()
    try
    {
      if (this.previousAnswerHtml !== this.quillAnswerHtml || QuestionserviceService.mathFieldChanged) {
        const data = this.questionservice.constructAnswerSaveData(this.schedulequestionid, this.scheduleid, [], true, this.examid, false, '');
        //this.questionservice.saveQuestionOption(data);
        if (await this.questionservice.allowEssayAnswerInput(this.previousQuestion)) {
          const updatedQuillAnswerHtml = QuestionserviceService.mathFieldChanged ? this.updateQuillHtmlWithMathFields(this.quillAnswerHtml) : this.quillAnswerHtml;
          //console.log(`Updated Quill Answer HTML: ${updatedQuillAnswerHtml}`);
          //console.log(`PRevious QUILL answer HTML: ${this.quillAnswerHtml}`);

          await this.questionservice.saveEssayAnswer(updatedQuillAnswerHtml, data);
          this.updatedanswer.emit(this.quillAnswerHtml)
          this.previousAnswerHtml = this.quillAnswerHtml;
          this.lastSavedTime = new Date();
        }
      }
      else {
        console.log(`Not saving because questionHtml has not changed`);
        // if(this.manualSave) // reset the last saved time even if the content hasn't changed so the user gets a feedback for clicking on the save button
        //   {
        //     this.lastSavedTime = new Date();
        //     this.manualSave = false;
        //   }
      }
    }
    finally{
      if(!this.destroyed){
        if (callback) callback();
      }
    }
  }
  
  updateQuillHtmlWithMathFields(quillHtml: string){
    let tempNode = document.createElement('span');
    tempNode.style.display = 'none'; // Make the span hidden
    tempNode.innerHTML = quillHtml; // Append the HTML content
    // Find all math-field elements
    const mathFields = tempNode.querySelectorAll('math-field');
      
    // Set each math-field's innerHTML from the service's mathFieldValues
    mathFields.forEach(field => {
      if (QuestionserviceService.mathFieldValues && 
        QuestionserviceService.mathFieldValues[field.id]) {
        field.innerHTML = QuestionserviceService.mathFieldValues[field.id];
      }
    });
    QuestionserviceService.mathFieldChanged = false;
    return tempNode.innerHTML;
  }
  get timeSinceLastSave(): number {
    if (!this.lastSavedTime) return 0;
    return Math.floor((new Date().getTime() - this.lastSavedTime.getTime()) / 1000);
  }
  
  callSaveData() {
    this.saveData(() => {
      setTimeout(() => { this.callSaveData(); }, 1000 * this.questionservice.essaySavingIntervalSeconds);//15s seconds
    });
  }

  // saveButtonClicked(){
  //   this.manualSave = true;
  //   this.saveData(null);
  // }
  getLastSavedText(): string {
    if (!this.lastSavedTime) return '';
    
    const seconds = Math.floor((new Date().getTime() - this.lastSavedTime.getTime()) / 1000);
    
    if (seconds < 60) {
      if (seconds < 10) return 'just now';
      if (seconds < 25) return 'a few seconds ago';
      return 'less than a minute ago';
      // return `${seconds} second${seconds !== 1 ? 's' : ''} ago`
    }

    if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    }
    const hours = Math.floor(seconds / 3600);
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }


  onEditorContentChange([html, plainText]: [string, string]) {
    this.quillAnswerHtml = html;

    const length = this.getWordCount(plainText);
    this.wordcountdisplay = !length[0] ? '' : length[0] + ' ' + 'word' + (length[0] > 1 ? 's' : '');
  }

  onEditorCreated() {
    this.callSaveData();
  }

  insertAnswerIntoEditor(content: string, readOnly: boolean) {
    if (this.editor) {
      this.editor.setValue(content);
      this.editor.setReadOnly(readOnly);
    } else {
      // If editor isn't ready yet, try 5 times with a delay
      let attempts = 0;
      const maxAttempts = 5;

      const tryInsert = () => {
        if (this.destroyed) {
          return;
        }

        if (this.editor) {
          this.editor.setValue(content);
          this.editor.setReadOnly(readOnly);
        } else if (++attempts < maxAttempts) {
          setTimeout(tryInsert, 100);
        }
      };

      tryInsert();
    }
  }
}


